import axios from "../axios";

class ListingService {
    getListingFullDetailsById(id) {
        const url = `listings/${id}/full-details`;
        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getListingFullDetailsBySlug(slug) {
        const url = `listings/slug/${slug}/full-details`;
        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getRegisterInterestFieldsWithListingDetails(slug) {
        const url = `listings/slug/${slug}/register-interest-full-details`;
        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getListingsFromUrl(url) {
        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getUpcomingOpenDaysByListingSlug(slug) {
        const url = `listings/slug/${slug}/upcoming-opendays`;
        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getUpcomingOpenDaysByListingId(id) {
        const url = `listings/${id}/upcoming-opendays`;
        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    checkBookingCode(id, code) {
        const url = `listings/${id}/check-booking-code`;
        return new Promise((resolve, reject) => {
            axios
                .post(url, {code: code})
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}

export default new ListingService();
